<template>
  <div class='container main'>
      <div class='menu'>
          <button class='sendbtn' @click='goSection("/editor")'>下发通知</button>
          <div class='btn_list'>
            <div  style="cursor:pointer" class='inbox item' @click='goSection("/inbox","all",0)' :class='{"selected":selecetedList[0]}'>
               <i style='margin-right:10px;' class="fa fa-inbox "></i><span>收件箱</span>
            </div>
             <div style="cursor:pointer" class='sendbox item' @click='goSection("/outbox","",1)' :class='{"selected":selecetedList[1]}'>
               <i style='margin-right:10px;' class="fa fa-envelope-o"></i><span>发件箱</span>
            </div>
          </div>
          <div class='btn_list category'>
            <span class='category_label'>分类</span>
            <div style="cursor:pointer" class='inbox item' @click='goSection("/inbox","system",2)' :class='{"selected":selecetedList[2]}'>
               <i class="fa fa-circle" style='color:#4283c1;margin-right:10px;'></i><span>系统消息</span>
            </div>
          </div>
      </div>
      <div class='section main'>
          <router-view :category='category'></router-view>
      </div>
  </div>  
</template>

<script>
export default {
  data () {
    return {
      category: '',
      // 选中状态列表
      selecetedList: [
        true,
        false,
        false
      ]
    }
  },
  methods: {
    goSection (url, category, index) {
      if (category) {
        this.category = category
      }
      for (let i = 0; i < this.selecetedList.length; i++) {
        if (i === index) {
          this.selecetedList[i] = true
        } else {
          this.selecetedList[i] = false
        }
      }
      this.$router.push(url)
    }
  }
}
</script>

<style scoped>
.container.main{
  padding-top:30px;
  display: flex;
  width:100%;
  height:930px;
}
.menu{
  margin-left:10px;
  margin-right:25px;
  width:20%;
  height:900px;
}
.section{
  width:75%;
  min-height:900px;
}
.sendbtn{
  width:100%;
  height:40px;
  background: #1AB393;
  border-radius: 5px;
  color:#eeeeee;
  border:none;
  box-shadow: 0px 0px 0px;
  
}
.btn_list{
  margin-top:50px;
}
.btn_list .item{
  font-size: 14px;
  border-bottom: 1px solid #dddddd;
  padding-bottom:5px;
 padding-top:5px;
 padding-left:10px;
}
.btn_list .selected{
  background-color: #e7e7e7;
}
.btn_list .item:hover{
   cursor:hand;
}
.category{

}
.category .category_label{
  font-weight: bolder;
  font-size:16px;
  margin-left:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/notice/main.vue